// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6402) return "static/chunks/6402-7bb815b2cce900cc.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6623 ? "77973763" : chunkId) + "." + {"3960":"78d50ad96cdc8a2f","6623":"2d18d302f469d5db","6938":"e10e33c073680e6b","9896":"52f9d8b892400e9f"}[chunkId] + ".js";
};